import { UserFullInfo } from '@entities/User/types/user.fullInfo'
import { KeycloakPostRequest } from '@entities/User/types/kc.get'

const hasField = <T extends object>(object: T, field: keyof T): boolean =>
	Object.prototype.hasOwnProperty.call(object, field)

const toKcAttribute = (value: unknown): string[] | undefined => {
	if (value === undefined || value === null) {
		return undefined
	}

	return [String(value)]
}

export const mapUserInfoToKc = (userInfo: Partial<UserFullInfo>): KeycloakPostRequest => {
	const attributes: Partial<KeycloakPostRequest['attributes']> = {}
	const notNestedFields: Omit<KeycloakPostRequest, 'attributes'> = {}

	if (hasField(userInfo, 'birthday')) attributes.birthday = toKcAttribute(userInfo.birthday)
	if (hasField(userInfo, 'stressLevel')) attributes.stressLevel = toKcAttribute(userInfo.stressLevel)
	if (hasField(userInfo, 'favoriteTrainingType'))
		attributes.favoriteTrainingType = toKcAttribute(userInfo.favoriteTrainingType)
	if (hasField(userInfo, 'contraindications'))
		attributes.contraindications = toKcAttribute(userInfo.contraindications)
	if (hasField(userInfo, 'physique')) attributes.physique = toKcAttribute(userInfo.physique)
	if (hasField(userInfo, 'favoriteSport'))
		attributes.favoriteSport = toKcAttribute(userInfo.favoriteSport)
	if (hasField(userInfo, 'yearsExperience'))
		attributes.yearsExperience = toKcAttribute(userInfo.yearsExperience)
	if (hasField(userInfo, 'sex')) attributes.sex = toKcAttribute(userInfo.sex)
	if (hasField(userInfo, 'trainingsPerWeek'))
		attributes.trainingsPerWeek = toKcAttribute(userInfo.trainingsPerWeek)
	if (hasField(userInfo, 'kilogramsDifferenceTarget'))
		attributes.kilogramsDifferenceTarget = toKcAttribute(userInfo.kilogramsDifferenceTarget)
	if (hasField(userInfo, 'fatnessLevel'))
		attributes.fatnessLevel = toKcAttribute(userInfo.fatnessLevel)
	if (hasField(userInfo, 'weight')) attributes.weight = toKcAttribute(userInfo.weight)
	if (hasField(userInfo, 'language')) attributes.language = toKcAttribute(userInfo.language)
	if (hasField(userInfo, 'experienceLevel'))
		attributes.experienceLevel = toKcAttribute(userInfo.experienceLevel)
	if (hasField(userInfo, 'caloriesPerDay'))
		attributes.caloriesPerDay = toKcAttribute(userInfo.caloriesPerDay)
	if (userInfo.trainingTargets && userInfo.trainingTargets.length > 0)
		attributes.trainingTargets = userInfo.trainingTargets
	if (hasField(userInfo, 'diet')) attributes.diet = toKcAttribute(userInfo.diet)
	if (hasField(userInfo, 'healthInformation'))
		attributes.healthInformation = toKcAttribute(userInfo.healthInformation)
	if (hasField(userInfo, 'activityLevel'))
		attributes.activityLevel = toKcAttribute(userInfo.activityLevel)
	if (hasField(userInfo, 'height')) attributes.height = toKcAttribute(userInfo.height)
	if (hasField(userInfo, 'avatarUrl')) attributes.avatarUrl = toKcAttribute(userInfo.avatarUrl)

	if (hasField(userInfo, 'firstName')) notNestedFields.firstName = userInfo.firstName
	if (hasField(userInfo, 'lastName')) notNestedFields.lastName = userInfo.lastName
	if (hasField(userInfo, 'email')) notNestedFields.email = userInfo.email

	return {
		...notNestedFields,
		attributes,
	}
}
